import styled from "styled-components";

export const SettingsNavigationWrapper = styled.div`
    box-sizing: border-box;
    width: 100%;
    height: calc(96% - 142px);
`;
